var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('material-category',{attrs:{"category":_vm.mutatedCategories,"is-static":true},on:{"newCategory":_vm.newCategory,"saveCategory":_vm.saveCategory,"deleteCategory":_vm.deleteCategory}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }